import React, { type PropsWithChildren, useCallback } from 'react';
import { Inline, Box, xcss } from '@atlaskit/primitives';

import { useIsUserLocatedBoard } from '../../controllers';
import { useIsJSMBoard } from '../../services';
import { Header } from './header';
import Menu from './menu';
import { useConfigQuery } from './utils';

const SettingsContainerContent = ({ children }: PropsWithChildren) => {
	const isJsm = useIsJSMBoard();
	const isUserLocatedBoard = useIsUserLocatedBoard();
	const [configQuery, setConfigParam] = useConfigQuery();

	const navigateSettings = useCallback(
		(configParam: string) => {
			setConfigParam(configParam);
		},
		[setConfigParam],
	);

	return (
		<Box paddingInline="space.500">
			<Header />
			<Inline>
				<Menu
					isJsm={isJsm}
					isUserLocatedBoard={isUserLocatedBoard}
					currentConfigQuery={configQuery}
					onNavigate={navigateSettings}
				/>
				<Box paddingBlockStart="space.300" paddingBlockEnd="space.250" xcss={pageStyles}>
					{children}
				</Box>
			</Inline>
		</Box>
	);
};

const pageStyles = xcss({
	flexGrow: 1,
});

export default SettingsContainerContent;
